import jsonapi from 'jsonapi-parse';
import Support from '@/models/read/User/Support';

export default $axios => () => ({
    async getResponsibleSupport(orderId) {
        return new Promise((resolve, reject) => {
            $axios.get(`/api/v1/support/orders/${orderId}/last-responsible-support`)
                .then((response) => {
                    resolve(new Support(jsonapi.parse(response.data).data));
                })
                .catch(() => {
                    resolve(null);
                });
        });
    },
});
